import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faCheck,
  faRocket,
  faCrown,
  faGem,
} from "@fortawesome/free-solid-svg-icons";

const embroideryPackages = [
  {
    name: 'Premium Package',
    icon: faRocket,
    tagline: 'Premium',
    price: 190,
    features: [
      { text: '15 Designs of up to 15,000 Stitches' },
      { text: '2 Jacket Back Logo Digitizing (Up to 85,000 Stitches)' },
      { text: '3 Simple 2+ Logos Vector Conversion' },
      { text: 'No Credit Card Required' },
      { text: '24/7 Ticket System, Client Dashboard Access' },
      { text: '8-12 Hours Turnaround Time' },
      { text: 'Unlimited Free Revisions' },
      { text: '24/7 Email and Live Chat Support' },
      { text: 'Phone Support (Working Hours)' },
      { text: 'Free Design File Backup' },
      { text: 'Dedicated Account Manager' },
      { text: 'Easy & Secure Payment System' },
      { text: '2-6 Hours Delivery (Extra $5 USD)' },
      { text: 'Designs exceeding 15,000 stitches: $0.90 USD per additional 1000 stitches' },
      { text: 'Jacket Back Designs exceeding 75,000 stitches: $0.90 USD per additional 1000 stitches' },
      { text: 'Complex, Hardcore, and Extremely Hardcore Vector Designs: Not Included' },
    ],
  },
  {
    name: 'Premium Gold Package',
    icon: faCrown,
    tagline: 'Premium Gold',
    price: 515,
    features: [
      { text: '18 Logo Digitizing (Up to 20,000 Stitches)' },
      { text: '4 Jacket Back Logo Digitizing (Up to 75,000 Stitches)' },
      { text: '5 Complex 2+ Logos Vector Conversion' },
      { text: 'No Credit Card Required' },
      { text: '24/7 Ticket System, Client Dashboard Access' },
      { text: '8-12 Hours Turnaround Time' },
      { text: 'Unlimited Free Revision' },
      { text: '24/7 Email and Live Chat Support' },
      { text: 'Free Design File Backup' },
      { text: 'Dedicated Account Manager' },
      { text: 'Easy & Secure Payment System' },
      { text: '2-6 Hours Delivery (Extra $5 USD)' },
      { text: 'Designs exceeding 20,000 stitches: $0.90 USD per additional 1000 stitches' },
      { text: 'Jacket Back Designs exceeding 75,000 stitches: Charged additionally as per regular pricing' },
    ],
  },
  {
    name: 'Premium Gold Plus Package',
    icon: faGem,
    tagline: 'Premium Gold Plus',
    price: 1015,
    features: [
      { text: '40 Logo Digitizing (Up to 25,000 Stitches)' },
      { text: '6 Jacket Back Logo Digitizing (Up to 100,000 Stitches)' },
      { text: '6 Complex 2+ Logos Vector Conversion' },
      { text: 'No Credit Card Required' },
      { text: '24/7 Ticket System, Client Dashboard Access' },
      { text: '8-12 Hours Turnaround Time' },
      { text: 'Unlimited Free Revision' },
      { text: '24/7 Email and Live Chat Support' },
      { text: 'Phone Support (Working Hours)' },
      { text: 'Free Design File Backup' },
      { text: 'Dedicated Account Manager' },
      { text: 'Easy & Secure Payment System' },
      { text: '2-6 Hours Delivery (Extra $5 USD)' },
      { text: 'Designs exceeding 25,000 stitches: $0.90 USD per additional 1000 stitches' },
      { text: 'Jacket Back Designs exceeding 100,000 stitches: Charged additionally as per regular pricing' },
    ],
  },
];

export default function MonthlySubscription() {
  return (
    <>
      <Header />

      <section className="breadcrumbsection">
        <div className='container'>
          <h1>Monthly Subscription</h1>
          <ul className='breadcrumblinks'>
            <li><Link to="/">Home</Link></li>
            <li><FontAwesomeIcon icon={faChevronRight} /></li>
            <li>Monthly Subscription</li>
          </ul>
        </div>
      </section>

      <section className="subscription-main-section packages-section">
        <div className="container">
          <div className="subscription-section-header text-center mb-5">
            <h2 className="subscription-section-title">Monthly Subscription Plans</h2>
            <div className="subscription-title-underline"></div>
            <p className="subscription-section-subtitle">
              Ongoing embroidery digitizing and vector artwork services with a set number of designs per month, delivered digitally via client portal or email download.
            </p>
          </div>

          <div className="subscription-packages-wrapper">
            <div className="row g-4 justify-content-center">
              {embroideryPackages.map((pkg) => (
                <div className="col-lg-4 col-md-6" key={pkg.name}>
                  <div className="subscription-package-card professional-package">
                    <div className="package-header">
                      <div className="package-icon">
                        <FontAwesomeIcon icon={pkg.icon} />
                      </div>
                      <h3 className="package-name">{pkg.name}</h3>
                      <p className="package-tagline">{pkg.tagline}</p>
                    </div>

                    <div className="package-pricing">
                      <div className="price-display">
                        <span className="currency">$</span>
                        <span className="amount">{pkg.price}</span>
                        <span className="period">/month</span>
                      </div>
                      <p className="billing-info">Billed monthly</p>
                    </div>

                    <div className="package-features">
                      <ul className="features-list">
                        {pkg.features.map((feature, index) => (
                          <li key={index} className="feature-item available">
                            <FontAwesomeIcon icon={faCheck} className="feature-icon" />
                            <span>{feature.text}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="package-cta">
                      <button className="subscription-btn btn-professional">
                        Get Subscription Now
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}
